
























































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import {
  StatusIndicator, StatusSettings, StatusSettingsResource,
} from '@/api/accountstatussettings/';

@Component({ computed: mapState(['fiId', 'configVersion']) })
export default class StatusSettingsDialog extends Vue {
  @Prop({ default: true })
  smallButton!: boolean;

  @Prop({ default: true })
  disabled!: boolean;

  @Prop()
  settings!: StatusSettings;

  @Prop()
  indicators!: StatusIndicator[];

  @Prop({
    default() {
      return new Set<string>();
    },
  })
  allStatusCodes!: Set<string>;

  @Prop({
    default() {
      return new Set<string>();
    },
  })
  allProductCodes!: Set<string>;

  @Prop({ default: '' })
  title!: string;

  @Prop({ default: '' })
  statusCodeLabel!: string;

  @Prop({ default: '' })
  productCodeLabel!: string;

  @Prop()
  settingsResource!: StatusSettingsResource;

  fiId!: string;

  configVersion!: string;

  originalStatusCodes: Set<string> = new Set();

  originalProductCodes: Set<string> = new Set();

  condition: string | null = null;

  selectedIndicators: StatusIndicator[] = [];

  statusIndicatorMissing: boolean = false;

  statusCodeRequired: boolean = false;

  productCodeRequired: boolean = false;

  conditionalLogicMissing: boolean = false;

  loading: boolean = false;

  dialog: boolean = false;

  saving: boolean = false;

  workingSettings: StatusSettings | null = null;

  isDirty: boolean = false;

  statusCodesMissing: boolean = false;

  statusCodeConflict: boolean = false;

  productCodesMissing: boolean = false;

  productCodeConflict: boolean = false;

  isFormValid: boolean = false;

  @Watch('dialog')
  onDialogToggle() {
    if (this.dialog) {
      this.loading = true;
      this.saving = false;

      if (!this.settings) {
        this.settings = this.settingsResource.createEmptySettings();
      }

      this.resetUsing(this.settings);

      this.loading = false;
      this.isDirty = false;
      this.conditionalLogicMissing = false;
      this.statusIndicatorMissing = false;
      this.statusCodesMissing = false;
      this.productCodesMissing = false;
    }
  }

  @Watch('configVersion')
  @Watch('fiId')
  onFiOrVersionChange() {
    this.dialog = false;
  }

  cancel() {
    this.dialog = false;
  }

  save() {
    // Force the combo to lose focus so that changes aren't lost
    let combo: any = this.$refs.statusCodes;
    combo.blur();

    combo = this.$refs.productCodes;
    if (combo) {
      combo.blur();
    }

    this.$nextTick(() => {
      this.validateForm();
      if (this.isFormValid) {
        this.saving = true;

        if (this.workingSettings!.active === false) {
            this.workingSettings!.active = true;
        }

        // call backing service - wait two ticks to allow user changes to be updated
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.settingsResource.save(this.fiId, this.workingSettings!).then(
              (savedSettings: StatusSettings) => {
                if (this.settings) {
                  Object.assign(this.settings, savedSettings);
                }
                this.resetUsing(savedSettings);
                this.$emit('success', savedSettings);
                this.dialog = false;
                this.saving = false;
              },
            ).catch((error: any) => {
              this.showError();
              this.saving = false;
            });
          });
        });
      }
    });
  }

  @Watch('condition')
  @Watch('selectedIndicators')
  @Watch('workingSettings', { deep: true })
  validateForm() {
    this.isDirty = true;
    this.validateStatusCodes();
    this.validateProductCodes();
    this.statusIndicatorMissing = this.indicators && this.indicators.length > 0 && this.selectedIndicators.length === 0;
    this.conditionalLogicMissing = this.selectedIndicators.length > 1 && this.condition === null;

    this.isFormValid = !this.statusCodeConflict && !this.statusIndicatorMissing && !this.conditionalLogicMissing && !this.statusCodesMissing && !this.productCodesMissing && !this.productCodeConflict;
    if (this.isFormValid) {
      this.updateStatusEnum();
    }
  }

  validateStatusCodes() {
    this.statusCodesMissing = this.statusCodesRequired() && (!this.workingSettings!.statusCodes || this.workingSettings!.statusCodes.length === 0);
    this.checkForStatusCodeConflict();
  }


  statusCodesRequired() : boolean {
    let required = true;
    if (this.indicators && this.indicators.length > 0) {
      required = false;
      for (let i = 0; i < this.selectedIndicators.length; i++) {
        if (this.selectedIndicators[i].statusCodeRequired) {
          required = this.selectedIndicators[i].statusCodeRequired;
          break;
        }
      }
    }
    this.statusCodeRequired = required;
    return required;
  }

  checkForStatusCodeConflict() {
    if (this.workingSettings!.statusCodes) {
      for (let i = 0; i < this.workingSettings!.statusCodes.length; i++) {
        const code: string = this.workingSettings!.statusCodes[i];
        if (
          !this.originalStatusCodes.has(code)
        && this.allStatusCodes.has(code)
        ) {
          this.statusCodeConflict = true;
          return;
        }
      }
    }
    this.statusCodeConflict = false;
  }

  validateProductCodes() {
    this.productCodesMissing = this.productCodesRequired() && (!this.workingSettings!.productCodes || this.workingSettings!.productCodes.length === 0);
    this.checkForProductCodeConflict();
  }

  productCodesRequired() : boolean {
    let required = false;
    if (this.indicators && this.indicators.length > 0) {
      for (let i = 0; i < this.selectedIndicators.length; i++) {
        if (this.selectedIndicators[i].productCodeRequired) {
          required = this.selectedIndicators[i].productCodeRequired;
          break;
        }
      }
    }
    this.productCodeRequired = required;
    return required;
  }

  checkForProductCodeConflict() {
    if (this.workingSettings?.productCodes) {
      for (let i = 0; i < this.workingSettings!.productCodes.length; i++) {
        const code: string = this.workingSettings!.productCodes[i];
        if (
          !this.originalProductCodes.has(code)
        && this.allProductCodes.has(code)
        ) {
          this.productCodeConflict = true;
          return;
        }
      }
    }
    this.productCodeConflict = false;
  }

  resetUsing(settings: StatusSettings) {
    this.workingSettings = { ...settings };

    this.originalStatusCodes = new Set<string>();
    if (settings.statusCodes) {
      settings.statusCodes.forEach((item: string) => {
        this.originalStatusCodes.add(item);
      });
    }

    this.originalProductCodes = new Set<string>();
    if (settings.productCodes) {
      settings.productCodes.forEach((item: string) => {
        this.originalProductCodes.add(item);
      });
    }

    if (this.indicators) {
      this.selectedIndicators = [];
      const indicatorVals = this.settingsResource.getIndicatorsFromSettings(settings);
      if (indicatorVals) {
        indicatorVals.forEach((val:string) => {
          for (let i = 0; i < this.indicators.length; i++) {
            if (this.indicators[i].enumValue === val) {
              this.selectedIndicators.push(this.indicators[i]);
              break;
            }
          }
        });
      }
    }

    this.condition = this.settingsResource.getConditionalFromSettings(settings);
  }

  updateStatusCodes() {
    this.$nextTick(() => {
      if (this.workingSettings!.statusCodes.length > 0) {
        const lastEntered: string | undefined = this.workingSettings!.statusCodes.pop();
        this.workingSettings!.statusCodes.push(...lastEntered!.split(','));
      }
      this.validateForm();
    });
  }

  updateProductCodes() {
    this.$nextTick(() => {
      if (this.workingSettings!.productCodes && this.workingSettings!.productCodes.length > 0) {
        const lastEntered: string | undefined = this.workingSettings!.productCodes!.pop();
        this.workingSettings!.productCodes.push(...lastEntered!.split(','));
      }
      this.validateForm();
    });
  }

  updateStatusEnum() {
    const indicatorVals:string[] = [];

    this.selectedIndicators.forEach((selected:StatusIndicator) => {
      indicatorVals.push(selected.enumValue);
    });

    this.settingsResource.setIndicatorsOnSettings(this.workingSettings!, indicatorVals, this.condition === 'OR');
  }

  showError() {
    const al = new Alert('An unexpected error occurred.', NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
